import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "theme/components/atoms/Icon";
import deprecateRenamedProperty from "web/core/dx/deprecateRenamedProperty";

const mapping = {
  success: "checkmark-circle",
  error: "cross-circle",
  info: "chevron-right-circle",
};

const appearanceToIcon = (appearance) => {
  if (!Object.prototype.hasOwnProperty.call(mapping, appearance)) {
    console.warn(
      `No icon referenced in 'InlineAlert' component for '${appearance}'`
    );
    return;
  }

  return mapping[appearance];
};

const InlineAlert = ({ appearance, type, withIcon, children }) => {
  if (!appearance) {
    appearance = deprecateRenamedProperty(
      "InlineAlert",
      "type",
      "appearance",
      type
    );
  }

  return (
    <div
      className={classNames("inline-alert", `inline-alert--${appearance}`, {
        "inline-alert--with-icon": withIcon,
      })}
    >
      {withIcon && (
        <Icon icon={appearanceToIcon(appearance)} title="" size="small" />
      )}
      <span className="inline-alert__message">{children}</span>
    </div>
  );
};

InlineAlert.propTypes = {
  type: PropTypes.oneOf(Object.keys(mapping)),
  appearance: PropTypes.oneOf(Object.keys(mapping)).isRequired,
  children: PropTypes.node,
  withIcon: PropTypes.bool,
};

export default InlineAlert;
